import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// CONSTANTS
import { LOCATIONS_HOME_PAGE } from '@/constants/locations';

// COMPONENTS
import Swimlanes from '@/components/Swimlanes';

// HELP

// STYLES
import BrowseByServiceSection from './styles';

function BrowseByService({ data, loadings }) {
  const [t] = useTranslation();

  const { title, subtitle } = t('home.browseByService', { returnObjects: true });

  return (
    <BrowseByServiceSection className="section browse-by-service">
      <div className="page-content">
        <Typography className="browse-by-service__title" variant="h3" component="h2" align="center">
          {title}
        </Typography>
        <Typography className="browse-by-service__subtitle p3 m-t-10 m-b-40" align="center">
          {subtitle}
        </Typography>
        <Swimlanes
          data={data}
          loadings={loadings}
          analyticsLocation={LOCATIONS_HOME_PAGE}
          loadingType="service"
        />
      </div>
    </BrowseByServiceSection>
  );
}

BrowseByService.defaultProps = {
  data: {},
  loadings: {},
};

BrowseByService.propTypes = {
  data: PropTypes.object,
  loadings: PropTypes.object,
};

export default BrowseByService;
